<template>
  <div class="wrapper">
    <FORM ref="childForm" @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable" @checkbox="checkbox" @btnclick="bthClick" :pageData="pageData"></table-page>
    <UPDATE ref="childUpdate" @submit="submit" :updateData="updateData"></UPDATE>
  </div>
</template>

<script>
    //table封装组件
    import tablePage from '@/views/mis/customerRelation/table.vue'
    import FORM from '../components/page/form.vue'
    import UPDATE from '../components/page/update.vue'
    import Qs from 'qs'
    //接口地址url的统一管理
    import URL from '@/views/mis/util/url'
    import DateUtil from '@/utils/IM/tradeDataUtil.js'
    import axios from 'axios'
    import download from '@/utils/download'

    let matchType = {"0": "有推荐人", "1": "匹配", "2": "不匹配", "3": "无推荐人"};
    let activeStatus = {"1": "已激活", "0": "未激活"};
    let levelType = {"mMIN":"迷你","mSTD":"标准","mVIP":"金钻"};
    let useInviteCode = {1:"有使用邀请码",2:"未使用邀请码"};
    export default {
        name: 'list',
        components: {
            tablePage,
            FORM,
            UPDATE
        },
        methods: {
            checkbox(row) {
                this.deleteIds = row.map(key => key.id).join(",");
            },
            /*表格按钮点击事件*/
            bthClick(clickName, row) {
                if (clickName == "update") {
                    this.$refs.childUpdate.open(row);
                }
            },
            /*查询表单按钮点击事件*/
            formclick(clickName, data) {
                if ("查询" == clickName || window.$t('mis.bt.query') == clickName) {
                    this.queryData = data;
                    this.$refs.childTable.defaultQueryData(data);
                } else if (window.$t('mis.bt.add') == clickName) {
                    this.$refs.childUpdate.open();
                } else if (window.$t('mis.bt.down') == clickName) {
                    //隐藏关键字段
                    const param = Object.assign(JSON.parse(JSON.stringify(data)), {exportHide: true});
                    download.exportExcel(URL.customerRelation.downloadList, param, window.$t('mis.relationList.customerRelation'));
                } else if (window.$t('mis.bt.export') == clickName) {
                    const param = Object.assign(JSON.parse(JSON.stringify(data)), {});
                    download.exportExcel(URL.customerRelation.downloadList, param, window.$t('mis.relationList.customerRelation'));
                }
            },
            /*新增或跟提交数据触发事件*/
            submit(model) {
                //根据是否包含id更新还是添加
                this.dataChanage(URL.customerRelation.edit, model, res => {
                    if (res.code == 0) {
                        this.$message.success(window.$t('mis.rewardDealList.confirmSuccess'));
                        this.$refs.childUpdate.close();
                        this.$refs.childTable.defaultGetData(this.queryData);
                    } else {
                        this.$message.success(window.$t('mis.rewardDealList.confirmFail'));
                    }
                })
            },
            dataChanage(url, option, suc, fail) {
                this.axios.post(url, Qs.stringify(option || {})).then(res => {

                    if (suc && (typeof suc == 'function')) suc(res);
                }).catch(res => {
                    if (fail && (typeof fail == 'function')) fail(res);
                })
            }
        },
        data() {
            return {
                deleteIds: "",
                queryData: {},
                /*新增或更新*/
                updateData: {
                    cols: [
                        {title: 'id', field: 'id', hidden: true},
                        {title: window.$t('mis.relationList.customerNum'), field: 'customerNum', disabled: true},
                        {title: window.$t('mis.relationList.mobilePhone'), field: 'mobilePhone', disabled: true},
                        {title: window.$t('mis.relationList.userName'), field: 'userName', disabled: true},
                        {title: window.$t('mis.relationList.userLevel'), field: 'userLevel', type: 2, optionList: levelType, disabled: true},
                        {title: window.$t('mis.relationList.createDate'), field: 'createDate', type: 5, disabled: true},
                        {title: window.$t('mis.relationList.activeTime'), field: 'activeTime', type: 5, disabled: true},
                        {title: window.$t('mis.relationList.newdirectPhone'), field: 'newdirectPhone', render: (data, full) => {
                               return full.directPhone;
                            }
                        },
                        {title: window.$t('mis.relationList.remark'), field: 'remark'},
                    ]
                },
                /*from查询表单*/
                formData: {
                    hasLable: true,
                    cols: [

                        {title: window.$t('mis.relationList.customerNumber'), field: 'customerNum'},
                        {title: window.$t('mis.relationList.phone'), field: 'phone'},
                        {title: window.$t('mis.relationList.beginDate'), field: 'beginDate', type: 5},
                        {title: window.$t('mis.relationList.endDate'), field: 'endDate', type: 5},
                        {title: window.$t('mis.relationList.userName'), field: 'userName'},
                        {title: window.$t('mis.relationList.direct'), field: 'direct'},
                        {title: window.$t('mis.relationList.matchType'), field: 'matchType', type: 2, optionList: matchType},
                        {title: window.$t('mis.relationList.activeStatus'), field: 'activeStatus', type: 2, optionList: activeStatus},
                        {title: window.$t('mis.relationList.useInviteCode'), field: 'useInviteCode', type: 2, optionList: useInviteCode},
                        {title: window.$t('mis.relationList.inviteCode'),field: 'inviteCode'},
                        {title: 'dataType', field: 'dataType', data: 0, hidden: true},
                        {click: window.$t('mis.bt.query')},
                        {click: window.$t('mis.bt.down')},
                        {click: window.$t('mis.bt.export')}
                    ]
                },
                /*table生成*/
                pageData: {
                    queryUrl: URL.customerRelation.list, //请求路径和参数
                    selection: true,
                    sequence: true,
                    cols: [
                        {title: window.$t('mis.relationList.customerNumber'), field: 'customerNum'},
                        {title: window.$t('mis.relationList.demoCustomerNum'), field: 'demoCustomerNum'},
                        {title: window.$t('mis.relationList.userName'), field: 'userName'},
                        {
                            title: window.$t('mis.relationList.userLevel'), field: 'userLevel', render: (data, full) => {
                                return levelType[data] || "";
                            }
                        },
                        {title: window.$t('mis.relationList.mobilePhone'), field: 'mobilePhone'},
                        {
                            title: window.$t('mis.relationList.createDate'), field: 'createDate', render: (data, full) => {
                                return DateUtil.formatDate(data, "yyyy-MM-dd hh:mm:ss");
                            }
                        },
                        {
                            title: window.$t('mis.relationList.activeTime'), field: 'activeTime', render: (data, full) => {
                                return DateUtil.formatDate(data, "yyyy-MM-dd hh:mm:ss");
                            }
                        },
                        {
                            title: window.$t('mis.relationList.activeStatus'), field: 'activeTime', render: (data, full) => {
                                if (full.activeTime > 0) {
                                    return "已激活";
                                } else {
                                    return "未激活";
                                }
                            }
                        },
                        {title: window.$t('mis.relationList.directNumber'), field: 'directNumber'},
                        {title: window.$t('mis.relationList.directPhone'), field: 'directPhone'},
                        {title: window.$t('mis.relationList.directInviteCode'), field: 'inviteCode'},
                        {title: window.$t('mis.relationList.indirectNumber'), field: 'indirectNumber'},
                        {title: window.$t('mis.relationList.indirectPhone'), field: 'indirectPhone'},
                        {
                            title: window.$t('mis.relationList.reStatus'), field: 'reStatus', render: (data, full) => {
                                if(data=="100") {
                                    if (full.directPhone === "") {
                                        return "无推荐人";
                                    } else {
                                        return "<label style='color: red;'>不匹配</label>";
                                    }
                                }
                                if (data == "110" || data == "111") return "<label style='color: green;'>匹配</label>";
                                return data;
                            }
                        },
                        {
                            field: window.$t('mis.bt.edit'),
                            title: window.$t('mis.bt.operation'),
                            size: "mini",
                            click: "update",
                            type: "primary",
                            icon: "el-icon-update"
                        }
                    ]
                }
            }
        }
    }
</script>
